import './App.css';
// import { Container } from 'semantic-ui-react'
import { BrowserRouter, Routes, Route,Navigate } from 'react-router-dom'
import React, { Component } from 'react';
import First from "./js/first"
import About from './js/about';
import Index from './js/index';
class main extends Component {
	
	render() {
		
		return (
			<BrowserRouter>
				<Routes>
					<Route path="/" element={<First />} >
						<Route path="/" element={<Navigate to="/index" replace />} />
						<Route path="/index" element={<Index />} />
						<Route path="/about/:type" element={<About />} />
					</Route>
				</Routes>
			</BrowserRouter>

		)
	}
}



export default main;
